import { Filenames } from '../../../cimsPage/instances/importsExports'
import { Simple } from '../../common'

const object = 'Filename'
const page = Filenames

export const ViewFilename = Simple({
  id: '02f244ec-70b5-4c57-bba1-ba44a36ab6b0',
  action: 'View',
  object,
  page,
})

export const EditFilename = Simple({
  id: '8fe11b05-5d12-4468-aafe-0b1a011cc8a5',
  action: 'Edit',
  object,
  page,
})

export type FilenamePermission = typeof ViewFilename | typeof EditFilename
